import React from "react";
import { SvgIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  icon: {
    width: 16,
    height: 16
  }
}));

function GridViewIcon(props) {
  const classes = useStyles();
  return (
    <SvgIcon viewBox="0 0 16 16" className={classes.icon}>
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0, 0, 400,400"
      >
        <g id="svgg">
          <path
            id="path0"
            d="M13.736 98.077 L 13.736 180.769 96.703 180.769 L 179.670 180.769 179.670 98.077 L 179.670
            15.385 96.703 15.385 L 13.736 15.385 13.736 98.077 M220.330 98.077 L 220.330 180.769 303.297
            180.769 L 386.264 180.769 386.264 98.077 L 386.264 15.385 303.297 15.385 L 220.330 
            15.385 220.330 98.077 M13.736 304.947 L 13.736 387.916 96.566 387.777 L 179.396 387.637
            179.535 304.808 L 179.674 221.978 96.705 221.978 L 13.736 221.978 13.736 304.947 M220.465
            304.808 L 220.604 387.637 303.434 387.777 L 386.264 387.916 386.264 304.947 L 386.264
            221.978 303.295 221.978 L 220.326 221.978 220.465 304.808 "
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default GridViewIcon;
